import { render, staticRenderFns } from "./DeliveryTime.vue?vue&type=template&id=7b6aa77c&lang=html"
import script from "./DeliveryTime.vue?vue&type=script&lang=js"
export * from "./DeliveryTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports